import { PureComponent, PropsWithChildren } from "react";

export default class InventoryFilterAdvancedFilterOption extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-inventory-filter__adv-filter-option">
        {this.props.children}
      </div>
    );
  }
}
